module.exports = __webpack_public_path__ + "6f0a15930f3ff00011054dc4076a8899.MP3";